/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function CaretExpanded(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
            transform='translate(7.5 9.5)'
            viewBox='0 0 24 24'
        >
            <path
                d='M4.76352 4.88599L8.88506 0.973707C9.06045 0.80704 9.06045 0.53511 8.88506 0.368444L8.60814 0.105286C8.43276 -0.061381 8.1466 -0.0613811 7.97122 0.105286L4.4866 3.41669L4.48199 3.41669L1.10352 0.206162C0.854293 -0.0306796 0.438909 -0.0569955 0.180447 0.175461C-0.0826302 0.412303 -0.087245 0.811426 0.166601 1.05265L3.96968 4.74564C3.98352 4.75879 4.00199 4.77634 4.02045 4.7895L4.12199 4.88599C4.30199 5.05265 4.58814 5.05265 4.76352 4.88599Z'
                fill={iconColor || '#666666'}
            />
        </SvgIcon>
    );
}